export default {
  // When the bound element is inserted into the DOM...
  inserted: function (el) {
    el.escape = function (e) {
      var code = e.keyCode || e.which || e.key || e.code;
      if (code === 'Escape' || code === 'escape' || code === 27) {
        var focused = document.activeElement && document.activeElement.tagName;
        if (focused === 'INPUT' || focused === 'SELECT' || focused === 'TEXTAREA') {
          document.activeElement.blur();
        } else {
          el.click();
        }
      }
    };
    document.addEventListener('keyup', el.escape);
  },
  unbind: function (el) {
    document.removeEventListener('keyup', el.escape);
  }
}


// WEBPACK FOOTER //
// ./src/helpers/components/interact/close.js